var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_1913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8747 6.91748H9.12551C7.88863 6.91748 6.88232 7.92379 6.88232 9.16067V16.9099C6.88232 18.1467 7.88863 19.1533 9.12551 19.1533H16.8747C18.1116 19.1533 19.1182 18.147 19.1182 16.9099V9.16067C19.1182 7.92379 18.1119 6.91748 16.8747 6.91748ZM13.0001 17.0634C10.7792 17.0634 8.97228 15.2564 8.97228 13.0353C8.97228 10.8144 10.7792 9.00743 13.0001 9.00743C15.2213 9.00743 17.0282 10.8144 17.0282 13.0353C17.0282 15.2561 15.221 17.0634 13.0001 17.0634ZM17.1577 9.84023C16.632 9.84023 16.2044 9.41268 16.2044 8.88722C16.2044 8.36176 16.632 7.93421 17.1577 7.93421C17.6832 7.93421 18.1107 8.36176 18.1107 8.88722C18.1107 9.41268 17.6832 9.84023 17.1577 9.84023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 10.709C11.7178 10.709 10.6738 11.7524 10.6738 13.0344C10.6738 14.3171 11.7178 15.3608 12.9999 15.3608C14.2825 15.3608 15.3256 14.3171 15.3256 13.0344C15.3256 11.7527 14.2822 10.709 12.9999 10.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.82058 0 0 5.82058 0 13C0 20.1794 5.82058 26 13 26C20.1794 26 26 20.1794 26 13C26 5.82058 20.1794 0 13 0ZM20.8199 16.9096C20.8199 19.0853 19.0503 20.8549 16.8746 20.8549H9.1254C6.95 20.8549 5.18013 19.0853 5.18013 16.9096V9.16045C5.18013 6.98505 6.95 5.21518 9.1254 5.21518H16.8746C19.0503 5.21518 20.8199 6.98505 20.8199 9.16045V16.9096Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_1913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.794793d9e44f33646518fef34a948004.svg";
export { ForwardRef as ReactComponent };